export default __webpack_public_path__ + "images/3cff48417a937f302d88b845d65dd517-tour_1_do.svg";